import NavigationExamApi from 'api/NavigationExamApi';
import ApiCaller from 'lib/ApiCaller';
import CancelledExamListTable, {
  ListTable,
  ListTableView,
} from './cancelledExamListTable';

class CancelledExamListPresenter {
  loggedUser: any;
  navigationExamApi: NavigationExamApi;
  table: ListTable;

  constructor(profile: any, private view: ListTableView) {
    this.loggedUser = profile;
    this.table = new CancelledExamListTable(this.loggedUser, view);
    this.navigationExamApi = new NavigationExamApi(
      new ApiCaller(this.loggedUser.token),
    );
  }

  async getAllExams(): Promise<any> {
    return await this.navigationExamApi.getCancelledExams();
  }

  getTableColumns() {
    return this.table.getColumns();
  }

  getTableName(): string {
    return this.table.getName();
  }
}

export default CancelledExamListPresenter;
